import Feedback from './components/Feedback.vue';
import { registerStore } from '@modules/common';
import createStore from './store';
import { MODULE_NAME } from './constants';

registerStore(MODULE_NAME, { store: createStore() });
export default Feedback;
